'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import UIFlex from 'UIComponents/layout/UIFlex';
const FeatureText = styled(FormattedMessage).withConfig({
  displayName: "ChecklistItem__FeatureText",
  componentId: "oxlndo-0"
})(["font-size:", "px;"], ({
  fontSize
}) => fontSize);
const StyledFlex = styled(UIFlex).withConfig({
  displayName: "ChecklistItem__StyledFlex",
  componentId: "oxlndo-1"
})(["cursor:", ";"], ({
  tooltipMessage
}) => tooltipMessage && 'help');

const ChecklistItem = ({
  tooltipMessage,
  message,
  secondaryMessage,
  className,
  iconName = 'success',
  iconColor = OBSIDIAN,
  fontSize = 14
}) => {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(UITooltip, {
      placement: "top",
      title: tooltipMessage && /*#__PURE__*/_jsx(FormattedMessage, {
        message: tooltipMessage
      }),
      children: /*#__PURE__*/_jsxs(StyledFlex, {
        className: className,
        tooltipMessage: tooltipMessage,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          className: "m-right-3",
          color: iconColor,
          name: iconName
        }), /*#__PURE__*/_jsx(FeatureText, {
          message: message,
          fontSize: fontSize
        }), secondaryMessage && /*#__PURE__*/_jsx("span", {
          className: "m-left-1",
          children: /*#__PURE__*/_jsx(FeatureText, {
            message: secondaryMessage,
            fontSize: fontSize
          })
        })]
      })
    })
  });
};

ChecklistItem.propTypes = {
  tooltipMessage: PropTypes.string,
  message: PropTypes.string.isRequired,
  secondaryMessage: PropTypes.string,
  className: PropTypes.string,
  iconName: PropTypes.string,
  iconColor: PropTypes.string,
  fontSize: PropTypes.number
};
export default ChecklistItem;